// extracted by mini-css-extract-plugin
module.exports = {"postActionsMenu":"PostActionsMenu__postActionsMenu__eGYm6"};